export default "__VITE_ASSET__f381c1c2__"